import * as React from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

import { paragraphs } from "./data";
import JourneyParagraph from "./journey-paragraph";

/**
 * Renders the journey section
 * Shows the journey paragraph
 */
const Journey = () => {
  const containerRef = React.useRef<HTMLDivElement>(null);

  useGSAP(() => {
    gsap.fromTo(
      containerRef.current,
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 1.5,
        ease: "power2",
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top bottom",
        },
      }
    );
  }, []);

  const containerStyles = `
    xs:mb-[13rem] vxs:mb-[16rem] vs:mb-[20rem] xs:mt-[19rem] group relative vs:mb-[23rem] vs:mt-[22rem] mb-[30rem] mt-[28rem] h-[calc(100vh-50px)] w-full sm:mt-[23rem] md:mb-[10rem] lg:mb-5 xl:mb-0
  `;

  const containerBgStyles = `
    vs:-top-52 absolute -left-32 -top-80 z-[-1] h-[400px] w-[150%] !rotate-[5deg] bg-[#0c0230] md:-top-60 lg:-top-44
  `;

  const contentContainerStyles = `
    xs:pb-28 relative flex h-screen items-center justify-center bg-gradient-to-t from-transparent via-[#13044d] to-[#0c0230] sm:pb-28 md:pb-44 lg:pb-48
  `;

  return (
    <section ref={containerRef} className={containerStyles}>
      <div className={containerBgStyles} />

      <div className={contentContainerStyles}>
        <div className="flex flex-col items-start justify-center gap-y-5">
          {paragraphs.map((p) => (
            <JourneyParagraph
              key={p.id}
              className={
                p.id === 1
                  ? "first-letter:text-6xl first-letter:font-semibold sm:first-letter:text-7xl md:first-letter:text-8xl"
                  : ""
              }
            >
              {p.content}
            </JourneyParagraph>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Journey;
